import { Link } from "react-router-dom";
import { Nav } from "@/components/site/Nav";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-cream text-olive-deep">
      <Seo title="Siden finnes ikke – Helserebellen" description="Beklager, vi fant ikke siden du lette etter." path="/404" noindex />
      <Nav />
      <div className="min-h-screen grid place-items-center px-6 text-center">
        <div>
          <p className="font-script text-4xl text-terra">404</p>
          <h1 className="mt-3 font-serif text-4xl">Siden finnes ikke</h1>
          <p className="mt-3 text-olive/70">Beklager, vi fant ikke siden du lette etter.</p>
          <Link to="/" className="mt-8 inline-flex rounded-md bg-terra px-8 py-4 text-cream text-[13px] font-semibold uppercase tracking-[0.12em] hover:bg-olive-deep transition-colors">Til forsiden</Link>
        </div>
      </div>
    </div>
  );
}
